import { HTTP } from '@/utils/http'
import Apis from '@/apis/index'

const TrackApis = {
    getDemoTracks: function (stationUid, searchTerm) {
        const params = {
            filters: [{
                    source: 'Tracks',
                    type: 'ValueList',
                    fieldName: 'isMixDemo',
                    include: true,
                    values: [true],
                }],
            stationUid,
            pageSize: 1,
            isAdvanced: true,
            //page: 1
        };
        return HTTP.post(Apis.library.tracks.advancedSearch, params);
    },
    
    getPlayUrl(stationUid, trackUid, playtoken)
    {
        var token = localStorage.getItem("accessToken");
        return  HTTP.defaults.baseURL + Apis.library.tracks.play + `?stationUid=${stationUid}&trackUid=${trackUid}&token=${playtoken}`
	}
};
export default TrackApis;